import { usePostHttp } from "../../../../hooks/http/http.hook";
import type { IOtp } from "../../../../types/models/otp.models.types";

interface IBody {
  email: string;
}


export function useEmailSendOtpBrandHttp() {
  return usePostHttp<IBody, IOtp>({
    path: "/brand/authentication/email/otp",
  });
}
